import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { CommunitySignalService } from './community/community.signal.service';

@Injectable({
  providedIn: 'root'
})
export class BuildItemsCommandService {
  private readonly router = inject(Router);
  private readonly communitySignalService = inject(CommunitySignalService);

  // Subject to emit submit form events
  private submitFormSubject = new Subject<void>();
  
  // Subject to emit save success events
  private saveSuccessSubject = new Subject<void>();
  
  // Observable that BuildItemsComponent subscribes to
  public submitForm$ = this.submitFormSubject.asObservable();
  
  // Observable that emits when save is successful
  public saveSuccess$ = this.saveSuccessSubject.asObservable();

  /**
   * Emit event to trigger form submission in BuildItemsComponent
   */
  public triggerFormSubmit(): void {
    this.submitFormSubject.next();
  }
  
  /**
   * Emit event when form save is successful and navigate to custom-form-builder
   */
  public emitSaveSuccess(): void {
    this.saveSuccessSubject.next();
    const communityId = this.communitySignalService.getCommunity()?.id;
    if (communityId) {
      this.router.navigate([`/community/${communityId}/custom-form-builder`], { queryParams: { fromService: true } });
    }
  }
}
